<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_20954_22342)">
			<path
				d="M3.91797 5.40039H8.70297C9.12464 5.40039 9.4913 5.68972 9.59214 6.10972L16.403 33.8577C16.6046 34.6884 17.338 35.2671 18.1813 35.2671H44.2513"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M40.582 44.6C42.1008 44.6 43.332 43.3464 43.332 41.8C43.332 40.2536 42.1008 39 40.582 39C39.0632 39 37.832 40.2536 37.832 41.8C37.832 43.3464 39.0632 44.6 40.582 44.6Z"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M19.5 44.6C21.0188 44.6 22.25 43.3464 22.25 41.8C22.25 40.2536 21.0188 39 19.5 39C17.9812 39 16.75 40.2536 16.75 41.8C16.75 43.3464 17.9812 44.6 19.5 44.6Z"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.918 10.0664H45.1863C45.718 10.0664 46.1396 10.5424 46.0846 11.0837L44.5355 26.0917C44.4438 26.9597 43.7746 27.6411 42.9313 27.7344L19.5013 30.1984"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M22.25 15.666V23.1327"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M29.582 15.666V23.1327"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M36.918 15.666V23.1327"
				:stroke="props.iconColor"
				stroke-width="1.6"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_20954_22342">
				<rect width="44" height="41.0667" fill="white" transform="translate(3 4.4668)" />
			</clipPath>
		</defs>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
